/*
 *	Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */
angular.module('access.Nodes')
    .factory('UploadTransport', [
        '$http',
        '$httpParamSerializer',
        '$q',
        'xsrfToken',
        function ($http, $httpParamSerializer, $q, xsrfToken) {
            function _onProgressHandler(onProgress, startTime, event) {
                if (!event.lengthComputable) {
                    // Progress computation is unavailable
                    return;
                }

                if (typeof onProgress !== 'function') {
                    return;
                }

                var percent = event.loaded * 100 / event.total;
                /**
                 * Time spent since upload began in seconds
                 * 
                 * @type {number}
                 */
                var timeSpent = (Date.now() - startTime) / 1000;
                var speed = Math.round(event.loaded / timeSpent);
                var bytesLeft = event.total - event.loaded;
                var timeLeft = bytesLeft > 0 ? Math.round(bytesLeft / speed) : 0;

                onProgress({
                    bytes: event.loaded,
                    percent: percent,
                    timeLeft: timeLeft
                });
            }

            return {
                /**
                 * Upload file to the certain url
                 * 
                 * @param {File} file - File instance to upload
                 * @param {string} url - Upload url
                 * @param {boolean} [sendAsStream=false] - Send file as a stream instead of part of FormData
                 * @param {function} onProgress - File upload progress callback
                 * @param {boolean} overwrite - Overwrite existing file
                 * @returns {Promise}
                 */
                uploadFile: function (file, url, sendAsStream, onProgress, overwrite) {
                    var headers = { 'Content-type': undefined };
                    Object.defineProperty(headers, xsrfToken.headerName, { value: xsrfToken.get() });

                    var query = angular.extend({
                        filename: file.name,
                        size: file.size
                    }, overwrite && { overwrite: true });

                    var data = null;

                    if (sendAsStream) {
                        data = file;
                        headers['Content-Type'] = 'application/octet-stream';
                    } else {
                        data = new FormData();
                        data.append('file', file, file.name);
                    }

                    var requestCanceler = $q.defer();
                    var requestPromise = $http.post(url + '?' + $httpParamSerializer(query), data, {
                        eventHandlers: {},
                        headers: headers,
                        ignoreApiErrors: true,
                        timeout: requestCanceler.promise,
                        uploadEventHandlers: {
                            progress: _onProgressHandler.bind(null, onProgress, Date.now())
                        }
                    });

                    return {
                        promise: requestPromise,
                        cancel: function () {
                            requestCanceler.resolve();
                        }
                    };
                }
            }
        }
    ])
